import axios from "axios";
import { getToken } from "./persist";
import getEnvEndpoints from "./endpoints";

const endpoints = getEnvEndpoints();

const axiosInstance = axios.create({
  baseURL: endpoints.baseApiUrl
});

const parseErrors = err => {
  console.log(err.response);
  if (err.response) {
    switch (err.response.status) {
      case 401:
        const path = `${window.location.pathname}${window.location.hash}`;
        window.location = `/login?redirect=${path}`;
        break;
      case 403:
        window.location = `/`;
        break;
      case 404:
        window.location = `/404`;
        break;
      default:
        throw err.response.data;
    }
  } else if (err.request) {
    console.log(err, "network error");
  } else {
    console.log("something unique happened");
  }
};

const createHeaders = (additionalHeaders = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...additionalHeaders
  };

  const token = getToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

export const makeRequest = async (
  method,
  url,
  data = {},
  additionalHeaders = {}
) => {
  const headers = createHeaders(additionalHeaders);

  try {
    const res = await axiosInstance({
      method,
      url,
      data,
      headers
    });
    return res.data;
  } catch (err) {
    parseErrors(err);
  }
};

export const fetcher = async (path, method = "get") => {
    try {
    const headers = createHeaders();
        const res = await axiosInstance[method](path, { headers });
    return res.data;
  } catch (err) {
    parseErrors(err);
  }
};

export const postsFetcher = async (path, data, options = {}) => {
  try {
    const headers = createHeaders();
    const res = await axiosInstance.post(path, data, { ...options, headers });
    return res.data;
  } catch (err) {
    parseErrors(err);
  }
};

export const logsFetcher = async (path, logType) => {
  try {
    const headers = createHeaders();
    const res = await axiosInstance.post(
      path,
      {
        logType: logType
      },
      { headers }
    );
    return res.data;
  } catch (err) {
    parseErrors(err);
  }
};

export const commentsFetcher = async (path, commentType) => {
  try {
    const headers = createHeaders();
    const res = await axiosInstance.post(
      path,
      {
        commentType: commentType
      },
      { headers }
    );
    return res.data;
  } catch (err) {
    parseErrors(err);
  }
};

export const anonymousFetcher = async path => {
  try {
    const res = await axiosInstance.get(path);
    return res.data;
  } catch (err) {
    parseErrors(err);
  }
};
